<template>
  <Transition
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    enter-active-class="transition ease-linear duration-200"
    leave-active-class="transition ease-linear duration-200 delay-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
    appear
  >
    <div v-show="isOpen" class="fixed inset-0 z-50 overflow-hidden">
      <Backdrop :show="isOpen" @click="toggle()" />
      <div
        class="bg-gray-200 fixed inset-0 inline-block opacity-50"
        @click="toggle()"
      ></div>

      <Transition
        enter-from-class="translate-y-full xl:translate-y-0 xl:translate-x-full"
        enter-to-class="translate-y-0 xl:translate-x-0"
        enter-active-class="transform transition-all duration-200 delay-75"
        leave-active-class="transform transition-all duration-200"
        leave-from-class="translate-y-0 xl:translate-x-0"
        leave-to-class="translate-y-full xl:translate-y-0 xl:translate-x-full"
      >
        <div
          v-show="isOpen"
          class="max-h-md fixed bottom-0 z-50 size-full overflow-y-auto bg-white shadow-sm xl:inset-y-0 xl:bottom-auto xl:right-0 xl:max-h-full xl:max-w-lg"
          :class="{ 'p-8 pb-0': !isMobile }"
        >
          <div class="relative" :class="{ 'flex h-full flex-col': isMobile }">
            <slot v-bind="toggle" name="slideInContent">
              <slot name="slideInHeader" :toggle="toggle" />
              <slot name="slideInBody" />
              <div
                class="sticky bottom-0 z-10 bg-white"
                :class="{ 'py-6': !isMobile, 'mt-auto': isMobile }"
              >
                <slot name="slideInActions" />
              </div>
            </slot>
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script lang="ts">
import useSlideIn from '../../../composables/useSlideIn'
import { useDeviceType } from '~/composables/useDeviceType'

export default defineComponent({
  name: 'SlideIn',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
  },
  emits: ['open', 'close'],

  setup({ name }, { emit }) {
    const { isMobile } = useDeviceType()
    const { isOpen, toggle } = useSlideIn(name)

    useWatch(isOpen, (newValue) => {
      emit(newValue ? 'open' : 'close')
    })

    return {
      isOpen,
      isMobile,
      toggle,
    }
  },
})
</script>
